export const name = 'containerSliderService' as const
